import { render, staticRenderFns } from "./Affairs.vue?vue&type=template&id=249832b2&scoped=true"
import script from "./Affairs.vue?vue&type=script&lang=js"
export * from "./Affairs.vue?vue&type=script&lang=js"
import style0 from "./Affairs.vue?vue&type=style&index=0&id=249832b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249832b2",
  null
  
)

export default component.exports